import { render, staticRenderFns } from "./PatentTransactionReportDetail.vue?vue&type=template&id=0b76ddf8&"
import script from "./PatentTransactionReportDetail.vue?vue&type=script&lang=js&"
export * from "./PatentTransactionReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./PatentTransactionReportDetail.vue?vue&type=style&index=0&id=0b76ddf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports